import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreateOrPatchMetadata, Metadata } from '@thro-types/billing';

import { AxiosRequestConfig } from 'axios';

import { createMetadata, getMetadata, updateMetadata } from 'api/billingService';

import { UpdateInterface } from '../../billingService';

export const useGetMetadataQuery = (config?: AxiosRequestConfig) => {
  const queryKey = ['metadata', config ? JSON.stringify(config.params) : ''];
  return useQuery({
    queryKey,
    queryFn: () => {
      return getMetadata(config);
    }
  });
};

export const useMetadataMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const queryKey = ['metadata'];
  const creation = useMutation<Metadata, Error, CreateOrPatchMetadata>({
    mutationFn: async args => {
      return await createMetadata(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  const update = useMutation<Metadata, Error, UpdateInterface<CreateOrPatchMetadata>>({
    mutationFn: async args => {
      return await updateMetadata(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  return { creation, update } as const;
};
